import { methods } from "../../utils/axios";

export default class AnswersAPI {
  static getAnswers(data){
    return methods.post('/collaborator_tests/answers_select', data);
  }
}